<template>
  <div class="card inventory-lookup">
    <div class="card__header">
      <h2>ICS Postal Code Upload</h2>
    </div>
    <div class="card__body">
      <el-row :gutter="24">
        <el-col :span="10">
          <div v-if="success === true" class="alert alert-success">
            File has been successfully imported!
          </div>
          <div v-if="message !== ''" class="alert alert-danger">
            {{message}}
          </div>
          <p>Records: {{records}}</p>
          Last Upload: {{last_upload}}
          <form @submit="formSubmit" enctype="multipart/form-data" ref="addImageForm">
            <input id="fileUpload" type="file" class="form-control" v-on:change="onChange" style="opacity: 0" ref="fileupload">
            <p>File: {{ filename }}</p>
            <el-button type="primary" @click="chooseFile()">Choose</el-button>
            <el-button type="primary" @click="formSubmit">Upload</el-button>
            <el-button type="primary" @click="resetForm()">Cancel</el-button>
          </form>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import axios from "../../repositories";
export default {
  mounted() {
    this.loadLastestResults();
  },
  data() {
    return {
      file: '',
      success: false,
      filename: '',
      records: 0,
      last_upload: '',
      message: '',

    };
  },
  methods: {
    loadLastestResults() {
      let existingObj = this;
      axios.get('/shipping-options/').then(function (response) {
        existingObj.records = response.data.records;
        existingObj.last_upload = response.data.last_upload;
      });
    },
    chooseFile() {
      document.getElementById("fileUpload").click()
    },
    resetForm() {
      this.file = '';
      this.$refs.fileupload.value = null;
      this.filename = '';
    },
    onChange(e) {
      this.filename = '';
      this.message = '';
      this.success = false;
      this.file = e.target.files[0];
      this.filename = this.file.name;
    },
    formSubmit(e) {
      e.preventDefault();
      let existingObj = this;
      const config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
      let data = new FormData();
      data.append('file', this.file);
      axios.post('/shipping-options/store_file', data, config)
          .then(function (res) {
            existingObj.success = res.data.success;
            existingObj.records = res.data.records;
            existingObj.last_upload = res.data.last_upload;
          })
          .catch(function (err) {
            existingObj.message = 'Problem with upload.  The records have not change.';
            existingObj.success = false;
            if (err?.message) {
              let message = JSON.parse(err.message);
              if (message.file?.[0]) {
                existingObj.message = '';
                existingObj.message = message.file[0];
              }
            }
          });
      this.resetForm();
    }
  }
}
</script>
